module.exports = __webpack_public_path__ + "images/none-55770304ecc11603e6d2ba59550c1a10.jpg";